import * as BBApi from '.'
const rootUrl = BBApi.host + '/press'

export type Notification = any
export type NotificationCreate = any
export type NotificationUpdate = any
export type NotificationQuery = any

export const query = async (query: NotificationQuery) => {
	const url = new URL(rootUrl)

	if (query.search) url.searchParams.append('search', query.search)
	if (query.type && query.type !== 'all') url.searchParams.append('type', query.type)

	const response = await BBApi.get(url.href)

	if (response.ok === false) {
		throw new Error('Query error occurred')
	}

	const notifications = await response.json()
	return notifications as Notification[]
}

export const create = async (notification: NotificationCreate) => {
	const response = await BBApi.post(rootUrl, notification)

	if (response.ok === false) {
		throw new Error('Notification not created')
	}
}

export const update = async (notificationId: number | string, notification: NotificationUpdate) => {
	const response = await BBApi.patch(rootUrl + '/' + notificationId, notification)

	if (response.ok === false) {
		throw new Error('Notification not updated')
	}
}

export const remove = async (notificationId: number | string) => {
	const response = await BBApi.del(rootUrl + '/' + notificationId)

	if (response.ok === false) {
		throw new Error('Notification not deleted')
	}
}
